define([
    'text!fnjihome2021-detail/component/swiper-project.html',
    // 'common/api',
    'jquery',
    '../common/utils',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!fnjihome2021-detail/component/swiper-project.css'

], function(
    tpl,
    // Api,
    $,Utils,
    Swipers
){
    return {
        template: tpl,
        data: function(){
            return {
                swipers: '',
                page: 0,
                isPC: true,
                imgWidth: []
            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwiperImages: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String
        },
        methods: {
            inits: function () {
                var obj = this;
                if($(window).width()<755){
                    obj.isPC = false;
                }
                if(this.SwiperType=='detail'){
                    obj.swipers = new Swipers('#swiper-container-homeDetail',{
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                        observer: true
                    });
                    setTimeout(function () {
                        obj.SwiperImages.forEach(function (item,index) {
                            obj.imgWidth.push($('.swiper-slide').eq(index).find('img').width());
                        });
                        $('.swiper-container-project').width($('.swiper-container-project').width()-1)
                    },1000);
                }
            },
            toPage: function(index){
                var obj = this;
                if(index==1){
                    if(parseInt(obj.page)<obj.SwiperImages.length){
                        obj.page+=1;
                    }
                }else {
                    if(parseInt(obj.page)>0){
                        obj.page-=1;
                    }
                }
                obj.swipers.slideTo(obj.page);
            }
        },
        watch: {
            SwiperImages: function () {
                this.inits();
            }
        },
        mounted: function(){
            // this.inits();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./fnjihome2021-detail/component/swiper-project.js
// module id = 104
// module chunks = 1 2 3